import { PlusOutlined } from '@ant-design/icons';
import { DndContext, DragOverlay } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { FormItem, useRelationEditor } from '@framework/form';
import { Alert, Input } from 'antd';
import React from 'react';
import { useBasicDndDragger } from '../../../../../../ui/dnd/hooks/useBasicDndDragger';
import { ITableColumnWidget } from '../ITableInputWidget';
import { SortableTableColumnItem } from './SortableTableColumnItem';
import { TableColumnView } from './TableColumnView';
import { TableColumnWidgetEditDrawer } from './TableColumnWidgetEditDrawer';
import { createTableWidgetInitialColumn } from './createTableWidgetInitialColumn';

export interface ITableColumnWidgetListProps {
  name: string;
}

/**
 * Componente con D'n'D per la configurazione della lista delle opzioni di widget checkbox/radio/select
 */
export function TableColumnWidgetList(props: ITableColumnWidgetListProps) {
  const { name } = props;

  const editor = useRelationEditor<ITableColumnWidget>(name);

  const { sensors, handleDragStart, handleDragEnd, itemIds, active } =
    useBasicDndDragger(editor);

  return (
    <div>
      {editor.items.length < 1 && (
        <Alert
          type="warning"
          showIcon
          message="Aggiungere almeno una Colonna"
        />
      )}

      <FormItem name={name} label={null}>
        <DndContext
          sensors={sensors}
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
          modifiers={[restrictToVerticalAxis]}
        >
          <SortableContext
            items={itemIds}
            strategy={verticalListSortingStrategy}
          >
            {editor.items.map((item, index) => (
              <SortableTableColumnItem
                item={item}
                uid={item.__uid!}
                key={item.__uid}
                active={active}
                onEdit={e => {
                  editor.handle.open(item);
                }}
                onRemove={e => {
                  editor.remove(item);
                }}
                onAdd={e => {
                  const widget = createTableWidgetInitialColumn(item.type, {
                    label: 'Nuova colonna',
                    code: `colonna_${editor.items.length}`,
                  });

                  if (!widget) return;

                  editor.handle.open(widget);
                }}
              />
            ))}
            <DragOverlay>
              {active && <TableColumnView item={active} />}
            </DragOverlay>
          </SortableContext>
        </DndContext>

        {/* Pulsanti da aggiunta */}
        <Input.Group compact>
          <TableColumnWidgetEditDrawer
            editor={editor}
            buttonProps={{
              type: 'dashed',
              size: 'large',
              icon: <PlusOutlined aria-hidden="true" />,
              style: { width: '40%' },
              children: 'Aggiungi Campo',
            }}
          />
        </Input.Group>
      </FormItem>
    </div>
  );
}
